import { render, staticRenderFns } from "./ArqPdf.vue?vue&type=template&id=4c51bd8c&scoped=true&"
import script from "./ArqPdf.vue?vue&type=script&lang=js&"
export * from "./ArqPdf.vue?vue&type=script&lang=js&"
import style0 from "./ArqPdf.vue?vue&type=style&index=0&id=4c51bd8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51bd8c",
  null
  
)

export default component.exports